export default __webpack_public_path__ + "static/media/up-arrow-graphic.59b96675.jpeg";